import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IParatikaPosInsatallmentHistory } from '../models/models'

export class ListParatikaPosInsatallmentHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionParatika/listParatikaPosInsatallmentHistory',
      requesterInfo,
    })
  }

  public async listParatikaPosInsatallmentHistory(guid: string): Promise<IParatikaPosInsatallmentHistory[]> {
    this.props.url = `${this.props.url}/?guid=${guid}`
    return await this.getAsync<IParatikaPosInsatallmentHistory[]>()
  }
}

